// extracted by mini-css-extract-plugin
module.exports = {"root":"InspectionContentEditor_root__HonVB","cardLeft":"InspectionContentEditor_cardLeft__17Fmr","cardRight":"InspectionContentEditor_cardRight__1NCMM"};